import React, { useState } from 'react';
import Login from './Login';
import VerifyEmail from './VerifyEmail';

const AuthModal = ({ triggerElement, initialView = 'login' }) => {
  const [show, setShow] = useState(false);
  const [activeModal, setActiveModal] = useState(initialView);

  const openModal = () => setShow(true);
  const closeModal = () => {
    setShow(false);
    setActiveModal(initialView);
  };

  const switchToLogin = () => setActiveModal('login');
  const switchToVerify = () => setActiveModal('verify');

  return (
    <>
      {triggerElement && React.cloneElement(triggerElement, { onClick: openModal })}
      {activeModal === 'login' ? (
        <Login show={show} handleClose={closeModal} openLogin={openModal} switchToVerify={switchToVerify} />
      ) : (
        <VerifyEmail show={show} handleClose={closeModal} switchToLogin={switchToLogin} />
      )}
    </>
  );
};

export default AuthModal;
